
import { IGlobalState } from "@/store";
import HEADER_MENU from "@/typings/app";
import { computed, defineComponent, reactive, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import loginModal from "../views/frontSite/modules/login.vue";
import editPasswordModal from "../views/frontSite/modules/editPassword.vue";

export default defineComponent({
  components: {
    loginModal,
    editPasswordModal,
  },
  setup() {
    const visibleModal = ref(false);
    const editPasswordVisibleModal = ref(false);
    const router = useRouter();
    const store = useStore<IGlobalState>();

    const state = reactive({
      userId: computed(() => store.state.user.id),
      enterpriseFullName: computed(() => store.state.user.enterpriseFullName),
      logoutDialogVisible: false,
      clickModalClose: false,
      isJLWX: computed(()=>/jlwx/.test(location.host))
    });

    // 头部当前选中的菜单下标
    const headerMenuIndex = computed({
      get: () => store.state.app.headerMenuIndex,
      set: (val) => {
        store.state.app.headerMenuIndex = val;
      },
    });

    function gotoRegister() {
      const routeData = router.resolve({name: 'register'});
      window.open(routeData.href, '_blank');
    }
    function gotoLogin() { 
      visibleModal.value = true;
    }
    function closeModal() {
      visibleModal.value = false;
    }
    function changeMenuIndex(index: HEADER_MENU) {
      headerMenuIndex.value = index;
      let name = "";
      switch (index) {
        case HEADER_MENU.HOME:
          name = "home";
          break;
        case HEADER_MENU.API:
          name = "documenthome";
          break;
        case HEADER_MENU.LOG:
          name = "log";
          break;
        case HEADER_MENU.PERSONAL:
          name = "personalhome";
          break;
      }
      router.push("/" + name);
    }
    function wantLogout() {
      state.logoutDialogVisible = true;
    }
    function logout() {
      document.cookie = "token=" + ";path=/";
      document.cookie = "userid=" + ";path=/";
      state.logoutDialogVisible = false;
      window.location.href = "/";
    }
    function gotoResetPassword() {
      editPasswordVisibleModal.value = true;
    }
    function closeEditPasswordModal() {
      editPasswordVisibleModal.value = false;
    }
    function gotoEditFactoryInfo(){
      router.push("/editfactoryinfo");
    }

    return {
      ...toRefs(state),
      HEADER_MENU,
      headerMenuIndex,
      visibleModal,
      editPasswordVisibleModal,
      gotoRegister,
      gotoLogin,
      closeModal,
      changeMenuIndex,
      wantLogout,
      logout,
      gotoResetPassword,
      closeEditPasswordModal,
      gotoEditFactoryInfo
    };
  }
});
